import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-factory-issue',
  templateUrl: './factory-issue.component.html',
  styleUrls: ['./factory-issue.component.css']
})
export class FactoryIssueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
